/**
 * @name getViewportWidth
 *
 * @description Returns the current viewport width in pixels
 *
 * @example
 * import { getViewportWidth } from '@workbench/core';
 *
 * getViewportWidth(); // 1024
 */
function getViewportWidth() {
  return Math.max(window.document.documentElement.clientWidth || 0, window.innerWidth || 0);
}

export { getViewportWidth as g };
